import Glide from '@glidejs/glide';

export class CustomAppDevelopment {
    store = null;

    async init(store) {
        this.store = store;
        await this._initCarousel();      
    }

    _initCarousel() {
        const caruselOptions = {
            autoplay: 4000,
            hoverpause: false,
            perView: 1
        };

        const glide = new Glide('.custom-app-development__carousel-of-screens', caruselOptions);
        glide.mount();
    }
}